export const CUSTOM_DRAGGABLE_ITEM_TYPES = {
  BULK_ADD_ONS: 'bulkAddOns',
  BULK_BOM_BUILDER_ROWS: 'bulkBomBuilderRows',
  DRAFT_BOM_FILE: 'draftBomFile',
  BULK_DISCOUNTS: 'bulkDiscounts',
  BULK_MATERIAL_OPERATIONS: 'bulkMaterialOperations',
  BULK_OPERATION_OPERATIONS: 'bulkOperationOperations',
  BULK_PART_FILES: 'bulkPartFiles',
  BULK_PRICING_ITEMS: 'bulkPricingItems',
  BULK_QUOTE_FILES: 'bulkQuoteFiles',
  BULK_QUOTE_ITEMS: 'bulkQuoteItems',
  BULK_QUOTE_ITEM_COMPONENTS: 'bulkQuoteItemComponents',
  ORDER_REVIEW_ITEM: 'orderReviewItem',
  VIEWS_VISIBLE_COLUMNS: 'viewsVisibleColumns',
  RULES_SIGNAL: 'rulesSignal',
  RULES_FILTER_GROUP: 'rulesFilterGroup',
  RULES_RESOLUTION: 'rulesResolution',
} as const;

export const DROP_RESULT_TYPES = {
  ADD_QUOTE_FILES_TO_ROW: 'addQuoteFilesToRow',
  BULK_CHANGE_QUOTE_FILE_CATEGORY: 'bulkChangeQuoteFileCategory',
  BULK_CONVERT_PART_FILES_TO_QUOTE_FILES: 'bulkConvertPartFilesToQuoteFiles',
  BULK_CONVERT_QUOTE_FILES_TO_COMPONENTS: 'bulkConvertQuoteFilesToComponents',
  BULK_CONVERT_QUOTE_ITEMS_TO_QUOTE_FILES: 'bulkConvertQuoteItemsToQuoteFiles',
  BULK_CREATE_LINE_ITEMS_FROM_FILES: 'bulkCreateLineItemsFromFiles',
  BULK_MOVE_QUOTE_FILES_TO_PART_FILES: 'bulkMoveQuoteFilesToPartFiles',
  BULK_REORDER_ADD_ONS: 'bulkReorderAddOns',
  BULK_REORDER_DISCOUNTS: 'bulkReorderDiscounts',
  BULK_REORDER_MATERIAL_OPERATIONS: 'bulkReorderMaterialOperations',
  BULK_REORDER_OPERATION_OPERATIONS: 'bulkReorderOperationOperations',
  BULK_REORDER_PRICING_ITEMS: 'bulkReorderPricingItems',
  BULK_REORDER_QUOTE_ITEMS: 'bulkReorderQuoteItems',
  BULK_REORDER_QUOTE_ITEM_COMPONENTS: 'bulkReorderQuoteItemComponents',
  REORDER_BOM_NODES: 'reorderBomNodes',
  REPARENT_BOM_NODES: 'reparentBomNodes',
  BOM_BUILDER_ASSIGN_PRIMARY_FILE: 'bomBuilderAssignPrimaryFile',
  BOM_BUILDER_ADD_SUPPORTING_FILES: 'bomBuilderAddSupportingFiles',
  MOVE_DRAFT_BOM_FILE_TO_QUOTE_FILES: 'moveDraftBomFileToQuoteFiles',
  UPLOAD_NATIVE_PART_FILES: 'uploadNativePartFiles',
  UPLOAD_NATIVE_QUOTE_FILES: 'uploadNativeQuoteFiles',
  REORDER_ORDER_REVIEW_ITEMS: 'reorderOrderReviewItems',
  VIEWS_REORDER_VISIBLE_COLUMNS: 'viewsReorderVisibleColumns',
  RULES_REORDER_SIGNALS: 'rulesReorderSignals',
  RULES_REORDER_FILTER_GROUPS: 'rulesReorderFilterGroups',
  RULES_MOVE_FILTER_GROUP_BETWEEN_SIGNALS: 'rulesMoveFilterGroupBetweenSignals',
  RULES_REORDER_RESOLUTIONS: 'rulesReorderResolutions',
} as const;
